var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 289.044,
    height: 384.1,
    viewBox: "0 0 289.044 384.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0.2 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M274,0c2.6,1.4,5.4,2.5,7.7,4.3,4.9,3.7,7.1,8.9,7.1,15,.1,14.5,0,29,0,43.5,0,4.4-2.2,6.9-5.7,6.9-3.4,0-5.5-2.6-5.5-7V21.1c0-7.3-2.6-9.9-10-9.9H48.7c-9.4,0-11.4,2-11.3,11.5,0,1,.1,2,.2,3.4h4.9c66.2,0,132.5.2,198.7-.2,13.6-.1,21.7,9.3,21.7,21.8-.3,97.9-.2,195.7-.2,293.6v5.1c3,0,5.8.3,8.4-.1,3.7-.4,5.7-3,6.3-6.5a33.81,33.81,0,0,0,.1-4.5V90.5c.2-3.5,2.4-5.8,5.5-5.8a5.61,5.61,0,0,1,5.6,5.4c.1,1.2.1,2.5.1,3.7q0,120.9.1,241.9c0,13-8,23.3-22.1,22.1a31.776,31.776,0,0,0-4.1.2v6.1q-.15,14.4-13.8,19.2c-.4.2-.8.5-1.2.7H14.8a58.081,58.081,0,0,1-7.4-4A17.8,17.8,0,0,1,0,365.1c-.1-17.2-.1-34.5,0-51.7,0-4.4,2.2-6.8,5.8-6.7,3.5.1,5.4,2.3,5.4,6.6v49.5c0,7.4,2.6,10,9.9,10H241.5c7.4,0,9.9-2.5,9.9-9.9V47.2c0-7.4-2.4-9.8-9.9-9.8H21.1c-7.4,0-9.9,2.5-9.9,9.9V282c0,1.4,0,2.8-.1,4.1a5.271,5.271,0,0,1-5.3,5.3c-3.2.2-5.1-1.7-5.8-4.8a22.879,22.879,0,0,1-.1-3.7c0-78.5.1-157-.1-235.5C0,34.8,8.6,25,21.3,26.1c1.5.1,2.9,0,4.8,0V19.8c.1-9.6,4.7-16,13.7-19.2.4-.2.8-.5,1.3-.7Q157.65.05,274,0Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M81.9,162.9a54.15,54.15,0,1,1,54.1-54A54.2,54.2,0,0,1,81.9,162.9ZM76.3,66.4c-22,2.1-39.2,23.4-37.2,45.7,2.1,24.2,22.7,41.3,47.2,39.3,19.1-1.6,38.7-20.8,37.5-37.2H84.6c-6.9,0-8.3-1.4-8.3-8.3ZM124,102.8c-.8-17.6-21.6-38.1-36.3-36v36Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M182.7,174.6h41.9c7.3,0,10.6,3.3,10.6,10.5v47.2c0,7.4-3.4,10.7-10.9,10.7H140.9c-7.6,0-11-3.4-11-10.9-.1-15.5,0-31,0-46.5,0-7.7,3.3-10.9,10.9-10.9C154.7,174.6,168.7,174.6,182.7,174.6ZM141.3,186v45.5h82.3V186Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M27.7,299.2V262.8c0-7.3,3.5-10.7,10.8-10.8h12c7.2.1,10.7,3.6,10.7,10.9v63c0,3.6.1,7.2,0,10.9-.2,6.2-3.8,9.7-9.9,9.8q-6.9.15-13.8,0c-6.1-.1-9.7-3.7-9.8-9.9Q27.7,317.95,27.7,299.2ZM39.1,335H49.7V263.5H39.1Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M102.6,309.4v27c0,6.6-3.5,10.1-10.2,10.1H79.7c-6.9-.1-10.4-3.4-10.4-10.3-.1-12.5,0-25,0-37.5,0-5.5-.1-11,0-16.5.1-6.7,3.6-10,10.3-10.1H92.3c6.9,0,10.4,3.4,10.4,10.3C102.6,291.4,102.6,300.4,102.6,309.4ZM91.2,335.2V283.7H80.7v51.5Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M110.7,321.7c0-5-.1-10,0-15,.1-5.9,3.7-9.5,9.6-9.6,4.7-.1,9.5-.1,14.2,0,5.8.1,9.4,3.5,9.5,9.4.2,10.2.2,20.5,0,30.7-.1,6-3.7,9.3-9.8,9.4q-6.9.15-13.8,0c-6.1-.1-9.6-3.7-9.7-9.9Zm11.5-13.3V335h10.5V308.4Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M188.3,116.2H153.5c-4.5,0-6.8-1.8-6.8-5.2-.1-3.4,2.2-5.3,6.6-5.3h69.6c4.3,0,6.8,2,6.7,5.3s-2.5,5.1-6.9,5.1C211.2,116.2,199.7,116.2,188.3,116.2Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M188.1,91.7H154.4c-1.2,0-2.8.4-3.7-.3-1.6-1.1-3.7-2.8-3.8-4.3-.1-1.7,1.5-4,3-5.3,1-.9,3.1-.7,4.7-.7h69.2c3.5.3,5.7,2.3,5.8,5.2.1,3-2.3,5.2-6,5.3C211.8,91.7,199.9,91.7,188.1,91.7Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M75.1,191.3h34.4c4.4,0,6.7,1.8,6.8,5.2,0,3.4-2.3,5.3-6.7,5.3H40c-4.4,0-6.7-1.9-6.6-5.3.1-3.3,2.3-5.1,6.5-5.1C51.7,191.3,63.4,191.3,75.1,191.3Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M188.1,130.3c11.6,0,23.2-.1,34.8.1a8.471,8.471,0,0,1,5.9,2.8c2,2.4.3,6.2-2.8,7.1a19.093,19.093,0,0,1-4.8.5H155c-1,0-2,0-3-.1-3.5-.4-5.5-2.4-5.3-5.5.3-3.3,2.3-4.8,5.5-4.9,5.6-.1,11.2,0,16.8,0C175.4,130.2,181.7,130.3,188.1,130.3Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M75.1,215.8h34.4c4.5,0,6.8,1.8,6.8,5.1s-2.3,5.3-6.7,5.3H40.1c-4.3,0-6.7-2-6.6-5.4.1-3.3,2.2-5,6.5-5Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M190.5,292.5h32.2c4.4,0,6.8,1.9,6.9,5.1.1,3.4-2.5,5.4-7,5.4H158.7c-4.5,0-6.8-1.7-6.8-5.1-.1-3.5,2.2-5.4,6.9-5.4Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M190.8,266.9h32.1c4.3,0,6.8,2,6.7,5.3-.1,3.2-2.5,5.1-6.6,5.2H158.3c-4.3,0-6.6-2-6.6-5.4.1-3.3,2.2-5,6.5-5C169.1,266.8,179.9,266.9,190.8,266.9Z",
    fill: "#0193e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M190.5,328.6H158.4c-4.4,0-6.7-1.8-6.6-5.3.1-3.3,2.3-5.1,6.4-5.1h64.7c4.3,0,6.8,2.1,6.7,5.4-.1,3.2-2.5,5.1-6.9,5.1C212,328.6,201.3,328.6,190.5,328.6Z",
    fill: "#0193e1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.7f4c80c022443824894fb258396cfc1f.svg";
export { ForwardRef as ReactComponent };